// extracted by mini-css-extract-plugin
export default {"row":"login-layout_row__cG+xo","col":"login-layout_col__vRDX1"};